<template>
  <div class="card">
    <div class="card-heading">
      {{ title }}
    </div>
    <div
      v-for="(item, i) in processedData"
      :key="i"
      class="data-item"
      @click.prevent="toggleFilter(item.name)"
    >
      <div class="meta-row">
        <p class="title">{{ item.name || "null" }}</p>
        <p>{{ item.count }}</p>
      </div>
      <div class="progress-track">
        <div class="progress-thumb" :style="`width: ${item.percentage}%`"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    data: Array,
    totalCount: Number,
  },
  computed: {
    processedData() {
      return this.data.map(item => ({
        name: item.name,
        count: item.count,
        percentage: (item.count / this.totalCount) * 100,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  background: var(--color-secondary);
  padding: 15px;

  .card-heading {
    margin-bottom: 10px;
  }

  .data-item {
    display: flex;
    flex-direction: column;
    min-height: 50px;
    /* margin: 0 15px; */
    /* cursor: pointer; */
    transition: 0.2s all ease-in-out;

    .meta-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 16px;

      p {
        margin: 0;
        padding: 0;
      }
      .title {
        flex: 1;
      }
    }

    .progress-track {
      position: relative;
      background-color: var(--border-color);
      min-height: 6px;
      border-radius: 10px;
      margin-top: 5px;

      .progress-thumb {
        position: absolute;
        left: 0;
        min-height: 6px;
        border-radius: 10px;
        background-color: var(--color-primary);
      }
    }
  }
}
</style>
